<template>
    <Dialog :open="open" :title="$t('circles.memberInfo')" @close="$emit('close')" @enter="save">
        <v-form v-model="valid">
            <v-row>
                <v-col cols="12">
                    <v-text-field
                            :value="user.FirstName"
                            disabled
                            hide-details
                            readonly
                            required>
                        <template v-slot:label>
                            {{ $t('authentication.firstName') }}
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-text-field
                            :value="user.LastName"
                            disabled
                            hide-details
                            readonly
                            required>
                        <template v-slot:label>
                            {{ $t('authentication.lastName') }}
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-text-field
                            :value="user.Email"
                            disabled
                            hide-details
                            readonly>
                        <template v-slot:label>
                            {{ $t('authentication.email') }}<sup>*</sup>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="6">
                    <v-switch
                            v-model="receiveNotifications"
                            :label="$t('circles.receiveNotifications')"
                            color="accent"
                            inset
                    ></v-switch>
                </v-col>
                <v-col v-if="isAdmin && userID !== user.UserID" cols="6">
                    <v-select
                            v-model="role"
                            :items="userRoles"
                            :label="$t('circles.role')"/>
                </v-col>
            </v-row>
            <v-row v-if="isAdmin">
                <v-col>
                    <div class="text-body-1 font-weight-bold">{{ $t('menu.circles') }}:</div>
                    <v-list>
                        <template v-for="(item, index) in circles">
                            <v-list-item :key="index">
                                {{ item.Name }}
                            </v-list-item>
                            <v-divider
                                    v-if="index < circles.length - 1"
                                    :key="index + 'div'"
                            ></v-divider>
                        </template>
                    </v-list>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="text-right">
                    <v-btn
                            class=" py-6 secondary--text shadow-inverse mr-5"
                            color="primary"
                            depressed
                            @click="$emit('close')">
                        {{ $t('close') }}
                    </v-btn>
                    <v-btn
                            :disabled="receiveNotifications === user.ReceiveNotifications && role === user.Role"
                            :loading="loading"
                            class=" py-6 accentText--text shadow-inverse"
                            color="accent"
                            depressed
                            @click="save">
                        {{ $t('save') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </Dialog>
</template>

<script>
import Dialog from "@/components/reusable/Dialog/Dialog";
import {CIRCLE_USER_ROLE_MANAGER, CIRCLE_USER_ROLE_USER} from "@/helper/constants";

export default {
  name: "PeopleDetailsDialog",
  components: {Dialog},
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    user: {
      type: Object,
      required: false,
      default: () => {
      }
    }
  },
  data() {
    return {
      valid: false,
      loading: false,
      emailInvitation: '',
      hasChanges: false,
      role: CIRCLE_USER_ROLE_USER,
      receiveNotifications: false,
      circles: [],
    };
  },
  computed: {
    organizationId() {
      return this.$store.getters.getOrganizationId;
    },
    isAdmin() {
      return this.$store.getters.isOrganizationAdmin;
    },
    userID() {
      return this.$store.getters.getUserId;
    },
    userRoles() {
      return [
        {text: this.$t('circles.user'), value: CIRCLE_USER_ROLE_USER},
        {text: this.$t('circles.manager'), value: CIRCLE_USER_ROLE_MANAGER},
      ];
    }
  },

  watch: {
    user: {
      handler(user) {
        this.receiveNotifications = user.ReceiveNotifications;
        this.role = user.Role;
        if (this.isAdmin) {
          const url = this.$store.getters.getUsersCircles(this.organizationId, user.UserID);
          this.axios.get(url).then(({data}) => {
            this.circles = data.Result;
          });
        }
      },
      deep: true,
    },
    open() {
      this.receiveNotifications = this.user.ReceiveNotifications;
      this.role = this.user.Role;
    }
  },
  methods: {
    sendInvitation() {
      const url = this.$store.getters.invitation(this.organizationId);
      this.axios.post(url, this.emailInvitation).then(() => {
        this.$emit('close');
        this.emailInvitation = '';
        this.$store.dispatch('addNotification', {
          type: 'success',
          message: this.$t('success.invitationSentSuccessful'),
        });
      });
    },
    save() {
      if (this.loading) {
        return;
      }
      let url = '';
      let finishRoleUpdate = false,
          finishNotificationUpdate = false,
          changeNotification = false,
          changeRole = false;
      this.loading = true;
      if (this.role !== this.user.Role) {
        changeRole = true;
        url = this.$store.getters.updateUserRoleInCircle(this.user.CircleID, this.user.UserID);
        this.axios.put(url, this.role).then(() => {
          finishRoleUpdate = true;
          if (!changeNotification || finishNotificationUpdate) {
            this.$emit('updateTable');

            this.$emit('close');
            this.$store.dispatch('addNotification', {
              type: 'success',
              message: this.$t('success.settingsWasUpdated'),
            });
          }
        }).finally(() => {
          this.loading = false;
        });
      }
      if (this.receiveNotifications !== this.user.ReceiveNotifications) {
        url = this.$store.getters.updateUserNotificationInCircle(this.user.CircleID, this.user.UserID);
        changeNotification = true;
        this.axios.put(url, this.receiveNotifications).then(() => {
          finishNotificationUpdate = true;
          if (!changeRole || finishRoleUpdate) {
            this.$emit('updateTable');
            this.$emit('close');
            this.$store.dispatch('addNotification', {
              type: 'success',
              message: this.$t('success.settingsWasUpdated'),
            });
          }
        }).finally(() => {
          this.loading = false;
        });
      }
    }
  }
};
</script>

<style scoped>

</style>